/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductCategoryCreateRequest
 */
export interface ProductCategoryCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateRequest
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCategoryCreateRequest
     */
    images?: Array<string>;
    /**
     * 
     * @type {Status}
     * @memberof ProductCategoryCreateRequest
     */
    status?: Status;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateRequest
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryCreateRequest
     */
    supplierId?: string;
}

/**
 * Check if a given object implements the ProductCategoryCreateRequest interface.
 */
// @ts-ignore
export function instanceOfProductCategoryCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

// @ts-ignore
export function ProductCategoryCreateRequestFromJSON(json: any): ProductCategoryCreateRequest {
    return ProductCategoryCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductCategoryCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'images': !exists(json, 'images') ? undefined : json['images'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'parentId': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
    };
}

// @ts-ignore
export function ProductCategoryCreateRequestToJSON(value?: ProductCategoryCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'images': value.images,
        'status': StatusToJSON(value.status),
        'parent_id': value.parentId,
        'external_code': value.externalCode,
        'supplier_id': value.supplierId,
    };
}

